import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import IColumn from "models/IColumn";
import { getFormatted } from "helpers/formatting";
import { URLS } from "constants/urlConstants";
import store from "../../../reduxStore";

const renderOrder = ({ Order, RoleId }) =>
  _.includes(store.getState().app.roles, "Orders") ? (
    <Link
      className="link"
      to={`${URLS.ORDERS_URL}/${Order.Id}?kooptype=${RoleId}`}
    >
      {Order.Number}
    </Link>
  ) : (
    Order.Number
  );

const renderMultipleInvoices = ({ Invoices, RoleId = "" }) => (
  <div>
    {_.isEmpty(Invoices)
      ? "-"
      : Invoices.map(({ Invoice }, index) => (
          <span key={Invoice.Id}>
            {_.includes(store.getState().app.roles, "Financieel") ? (
              <Link
                className="link"
                to={`${URLS.INVOICES_URL}/${Invoice.Id}?kooptype=${RoleId}`}
              >
                {Invoice.Number}
              </Link>
            ) : (
              Invoice.Number
            )}
            {index !== Invoices.length - 1 && " | "}
          </span>
        ))}
  </div>
);

export const deliveryLinesColumns: IColumn[] = [
  {
    title: "DELIVERIED_QUANTITY",
    key: "ShippedQuantity",
    fixedWidth: 128,
    type: "number",
    visible: true
  },
  {
    title: "UNIT",
    key: "ShippedQuantityUnit.Description",
    visible: true
  },
  {
    title: "DELIVERIES_TYPE",
    key: "TypeId",
    visible: true
  },
  {
    title: "ARTICLE_DESCRIPTION",
    key: "Item.Description",
    render: ({ Item, GrowerClaims }) =>
      Item ? Item.Description + GrowerClaims : "-",
    visible: true
  },
  {
    title: "SIZE",
    key: "Size.Description",
    visible: true
  },
  {
    title: "DELIVERIES_BKD",
    key: "CertificateNumber",
    visible: true
  },
  {
    title: "DELIVERIES_CERTIFICATE",
    key: "CertificateType",
    visible: false
  },
  {
    title: "DELIVERIES_CLASS",
    key: "Class.Code",
    visible: true
  },
  {
    title: "DELIVERIES_AM",
    key: "AMStatus",
    visible: true
  },
  {
    title: "BIO",
    key: "Bio",
    type: "boolean",
    visible: true
  },
  {
    title: "ORDERS_NUMBER",
    key: "OrderLine.Order.Number",
    render: rowData =>
      rowData.OrderLine
        ? renderOrder({ ...rowData, Order: rowData.OrderLine.Order })
        : "-",
    visible: true
  },
  {
    title: "INVOICES_NUMBER",
    key: "Invoices",
    render: renderMultipleInvoices,
    visible: true
  }
];

export const fustLinesColumns: IColumn[] = [
  {
    title: "DELIVERIED_QUANTITY",
    key: "Quantity",
    fixedWidth: 128,
    type: "absolute",
    visible: true
  },
  {
    title: "TYPE",
    key: "OwnerTypeId",
    visible: true
  },
  {
    title: "KIND",
    key: "Item.Description",
    visible: true
  },
  {
    title: "DELIVERIES_TRANSFER",
    key: "Transfer",
    visible: true
  },
  {
    title: "DELIVERIES_PRICE_PER_ONE",
    key: "Price",
    type: "currency",
    visible: true
  },
  {
    title: "TOTAL",
    key: "Totaal",
    render: ({ Quantity, Price }) => getFormatted(Quantity * Price, "currency"),
    visible: true
  },
  {
    title: "ORDERS_NUMBER",
    key: "Order.Number",
    render: renderOrder,
    visible: true
  },
  {
    title: "INVOICES_NUMBER",
    key: "Invoices[0].Invoice.Number",
    render: renderMultipleInvoices,
    visible: true
  }
];

export const costLinesColumns: IColumn[] = [
  {
    title: "KIND",
    key: "Item.Description",
    visible: true
  },
  {
    title: "DESCRIPTION",
    key: "Specification",
    visible: true
  },
  {
    title: "AMOUNT",
    key: "Amount",
    type: "currency",
    visible: true
  },
  {
    title: "ORDERS_NUMBER",
    key: "Order.Number",
    render: renderOrder,
    visible: true
  },
  {
    title: "INVOICES_NUMBER",
    key: "Invoices[0].Invoice.Number",
    render: renderMultipleInvoices,
    visible: true
  }
];
